export const inputStyles = {
  padding: '8px 10px',
  borderRadius: '6px',
  fontFamily: "'Open Sans', Arial, sans-serif",
};
